export enum WorkDiscountOption {
  PercentageDiscount = 'PERCENTAGE_DISCOUNT',
  DiscountedWorkRate = 'DISCOUNTED_WORK_RATE',
}
